import type { PluginDefaultTranslationsObject } from '../types.js'

export const lt: PluginDefaultTranslationsObject = {
  '@seshuk/payload-storage-bunny': {
    // TUS Upload
    tusUploadChecking: 'Tikrinami ankstesni įkėlimai...',
    tusUploadDisableMode: 'Išjungti TUS režimą',
    tusUploadEnableMode: 'Įjungti TUS režimą',
    tusUploadErrorFileType: 'Failo tipas neleidžiamas',
    tusUploadErrorInitUpload: 'Nepavyko inicijuoti įkėlimo',
    tusUploadErrorPrevCheckFail: 'Nepavyko patikrinti ankstesnių įkėlimų',
    tusUploadErrorRestoreUpload: 'Nepavyko atkurti įkėlimo',
    tusUploadFileSize: '{{size}} MB',
    tusUploadFinalizing: 'Baigiama...',
    tusUploadPause: 'Pauzė',
    tusUploadPreparing: 'Ruošiamas įkėlimas...',
    tusUploadResume: 'Tęsti',
    tusUploadRetry: 'Bandyti dar kartą',
    tusUploadStartOver: 'Pradėti iš naujo',
    tusUploadStartUpload: 'Pradėti įkėlimą',
    tusUploadStatusChecking: 'Tikrinami ankstesni įkėlimai...',
    tusUploadStatusCompleted: 'Įkėlimas sėkmingai baigtas!',
    tusUploadStatusFinalizing: 'Baigiamas įkėlimas...',
    tusUploadStatusIdle: 'Pasiruošęs įkėlimui',
    tusUploadStatusIdleWithRestore: 'Pasiruošęs tęsti arba pradėti iš naujo',
    tusUploadStatusPaused: 'Įkėlimas pristabdytas {{progress}}%',
    tusUploadStatusUploading: 'Įkeliama... {{progress}}%',
    tusUploadTimeHours: 'v',
    tusUploadTimeMinutes: 'm',
    tusUploadTimeSeconds: 's',

    // Error messages
    errorAccessDenied: 'Neturite leidimo pasiekti šį išteklių',
    errorDeleteFileFailed: 'Nepavyko ištrinti failo: {{filename}}',
    errorMissingRequiredFields: 'Trūksta reikalingos informacijos',
    errorNoServiceConfigured: 'Nėra sukonfigūruotos paslaugos',
    errorStreamConfigMissing: 'Bunny Stream nėra tinkamai sukonfigūruotas',
    errorTitleRequired: 'Prašome įvesti savo vaizdo įrašo pavadinimą',
    errorUploadFileFailed: 'Nepavyko įkelti failo: {{filename}}',
  },
}
